import styled from 'styled-components'
import { Text } from 'rebass'
import React, { useCallback, useState } from 'react'

const Wrapper = styled.div`
  position: relative;
`
const errorClass = 'ERRORCLASS'
const InputStyle = styled.input.attrs({
  errorClass,
})<{ width?: string; height?: string; padding?: string; margin?: string; weight?: string; size?: string; borderColor?: string; errorBorder?: boolean }>`
  width: ${({ width }) => (width ? width : '100%')};
  height: ${({ height }) => (height ? height : '36px')};
  padding: ${({ padding }) => (padding ? padding : '0 16px')};
  margin: ${({ margin }) => (margin ? margin : '0px')};
  font-weight: ${({ weight }) => (weight ? weight : '500')};
  font-size: ${({ size }) => (size ? size : '14px')};
  color: ${({ theme }) => theme.white};
  outline: none;
  background: rgba(255, 255, 255, 1);
  border: 1px solid ${({ borderColor }) => borderColor ? borderColor : '#FFFEFE'};
  border-radius: 5px;
  background: linear-gradient(305.04deg,#FFD600 -43.12%,#FF7A00 70.33%);
  -webkit-background-clip: text;
  color: transparent;
  caret-color: gray;

  &:focus {
    border: 1px solid ${({ errorBorder, borderColor }) => errorBorder ? borderColor ? borderColor : '#FFFEFE' : '#c0c9f0'};
  }

  &::placeholder {
    color: #b5b6c4;
  }

  &.${errorClass} {
    border: 1px solid ${({ errorBorder, borderColor }) => errorBorder ? borderColor ? borderColor : '#FFFEFE' : '#ff4473'};
  }
`
const ErrorText = styled(Text)<{ height?: string }>`
  color: #ff4473;
  font-size: 12px;
  position: absolute;
  top: ${({ height }) => (height ? height : '36px')};
  width: 100% !important;;
  height: 15px !important;
`

export default function SetInput({
  placeholder,
  inputChange,
  inputBlur,
  id = null,
  type = null,
  name = null,
  handleFocus = null,
  value,
  saveError = false,
  showError = true,
  errorMsg = null,
  ...rest
}: any) {
  const [errorStyle, setErrorStyle] = useState(false)

  const handleOnBlur = useCallback(
    (type, event) => {
      if (!value) {
        setErrorStyle(true)
      } else {
        setErrorStyle(false)
      }
      inputBlur && inputBlur(type, event)
    },
    [value, inputBlur]
  )

  return (
    <Wrapper>
      <InputStyle
        {...rest}
        id={id}
        name={name}
        type={type}
        placeholder={placeholder}
        maxLength={100}
        value={value}
        className={errorStyle ? errorClass : ''}
        onChange={(event) => {
          if (type) {
            inputChange(type, event)
          } else {
            inputChange(event)
          }
        }}
        onFocus={(event) => {
          handleFocus && handleFocus(event)
        }}
        onBlur={() => {
          handleOnBlur(type, event)
        }}
      ></InputStyle>
      {(errorStyle || saveError) && showError && errorMsg && <ErrorText {...rest}>{errorMsg}</ErrorText>}
    </Wrapper>
  )
}
